import React from 'react';
import Typography from '@mui/material/Typography';
import styled from '@emotion/styled';

const STypography = styled(Typography)`
  && {
    margin-top: var(--medium);
    font-weight: bold;
    color: transparent;
    background-color: transparent;
    background-image: linear-gradient(128deg, #bc0058 0, #1900a7 100%);
    background-clip: text;
    -webkit-background-clip: text;
    vertical-align: middle;
  }
`;

export const Heading2 = ({ children, fancy = true, ...props }) => (
  <>
    {fancy ? (
      <STypography variant="h5" component="h2" {...props}>
        {children}
      </STypography>
    ) : (
      <Typography variant="h5" component="h2" {...props}>
        {children}
      </Typography>
    )}
  </>
);
